import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useRoutePlanDelete } from '../apiHooks';
import utils from '../../utils/utils';
import DATE_FORMAT from '../../components/constants/dateFormat';
import ErrorMessage from '../../components/errorMessage';
import { Link } from 'react-router-dom';
import RoutePlanVehiclePreview from './routePlanVehiclePreview';

const RoutePlanPreview = ({ routePlan, setEditRoutePlan }) => {
  const {
    deleteRoutePlan,
    isLoading: deleteLoading,
    isError: isDeleteError,
    error: deleteError,
  } = useRoutePlanDelete();

  const deliveryDate = utils.getDateFromString(routePlan.deliveryDate);

  const { formatMessage } = useIntl();

  return (
    <div key={routePlan.id} className="route-planner__plan m-b-6">
      {isDeleteError ? <ErrorMessage error={utils.getErrorMessageFromResponse(deleteError)} /> : ''}

      <h3>{routePlan.name}</h3>
      <div className="m-b-3">
        <div>
          🏠{' '}
          <FormattedMessage
            id={'route.planner.view.starting.address'}
            values={{ address: routePlan?.startingAddress?.street }}
          />
        </div>
        <div className="m-b-2">🗓 {deliveryDate.format(DATE_FORMAT.displayWeekdayAndDate)}</div>
        {routePlan.vehicles?.map((vehicle) => {
          return <RoutePlanVehiclePreview key={vehicle.id} vehicle={vehicle} gray={true} />;
        })}
      </div>
      <div>
        <Link to={`/routePlanner/view/${routePlan.id}`} className={`btn btn-primary btn-small m-r-2`}>
          <FormattedMessage id={'route.planner.plans.cta.view'} />
        </Link>
        <button className={`btn btn-default btn-small m-r-2`} onClick={() => setEditRoutePlan(routePlan)}>
          <FormattedMessage id={'route.planner.plans.cta.edit'} />
        </button>
        <button
          className={`btn btn-danger btn-small m-r-2 ${deleteLoading ? 'btn-loading' : ''}`}
          onClick={() => {
            if (window.confirm(formatMessage({ id: 'route.planner.plans.cta.delete.confirm' }))) {
              deleteRoutePlan({ routePlan });
            }
          }}
        >
          <FormattedMessage id={'route.planner.plans.cta.delete'} />
        </button>
      </div>
    </div>
  );
};

export default RoutePlanPreview;
